import {createSlice} from "@reduxjs/toolkit";

import {getSubMenu, createSubMenu, updateSubMenu, deleteSubMenu} from "./thunk";

export const initialState = {
    subMenu: [],
    errors: {}
};

const SubMenuSlice = createSlice({
    name: 'SubMenu',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getSubMenu.fulfilled, (state: any, action: any) => {
            state.subMenu = action.payload;
        });
        builder.addCase(getSubMenu.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(createSubMenu.fulfilled, (state: any, action: any) => {
            state.subMenu.unshift(action.payload);
        });
        builder.addCase(createSubMenu.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateSubMenu.fulfilled, (state: any, action: any) => {
            state.subMenu = state.subMenu.map((subMenu: any) =>
                subMenu.id === action.payload.id
                    ? {...subMenu, ...action.payload}
                    : subMenu
            );
        });

        builder.addCase(updateSubMenu.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteSubMenu.fulfilled, (state: any, action: any) => {
            state.subMenu = state.subMenu.filter(
                (subMenu: any) => subMenu.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteSubMenu.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default SubMenuSlice.reducer;